module.exports = __webpack_public_path__ + "static/img/takenajadisabled.797e05c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/takenajadisabled.svg
// module id = X0wZ
// module chunks = 0